/* eslint-disable no-sequences */
/* eslint-disable object-shorthand */
/* eslint-disable vars-on-top */
/* eslint-disable no-unused-expressions */
/* eslint-disable prettier/prettier */
/* eslint-disable func-names */
/* eslint-disable no-param-reassign */
/* eslint-disable prefer-rest-params */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable no-var */
import { isUsingMobileApp } from 'helpers/device';
import Location from './Location';

declare const window: any;

class ChatWidget {
  widgetLoaded = false;

  init(): void {
    if (this.shouldRenderWidget()) {
      this.widgetLoaded = true;

      /* eslint-disable no-underscore-dangle */
      window.__lc = window.__lc || {};
      window.__lc.license = 1520;
      (function (n, t, c) {
        function i(n) {
          return e._h ? e._h.apply(null, n) : e._q.push(n);
        }
        var e = {
          _q: [],
          _h: null,
          _v: '2.0',
          on: function () {
            i(['on', c.call(arguments)]);
          },
          once: function () {
            i(['once', c.call(arguments)]);
          },
          off: function () {
            i(['off', c.call(arguments)]);
          },
          get: function () {
            if (!e._h) throw new Error("[LiveChatWidget] You can't use getters before load.");
            return i(['get', c.call(arguments)]);
          },
          call: function () {
            i(['call', c.call(arguments)]);
          },
          init: function () {
            var n = t.createElement('script');
            (n.async = !0),
              (n.type = 'text/javascript'),
              (n.src = 'https://cdn.livechatinc.com/tracking.js'),
              t.head.appendChild(n);
          },
        };
        !n.__lc.asyncInit && e.init(), (n.LiveChatWidget = n.LiveChatWidget || e);
      })(window, document, [].slice);
    }
  }

  handleContactSupport = (e): void => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    if (this.widgetLoaded) {
      this.invokeAPIMethod('maximize_chat_window');
    } else {
      window.open('https://www.livechat.com/contact/');
    }
  };

  shouldRenderWidget(): boolean {
    if (
      Location.isInLoginButtonPopup() ||
      Location.isInIframe() ||
      Location.getPathName() === 'consent' ||
      isUsingMobileApp()
    ) {
      return false;
    }

    return true;
  }

  invokeAPIMethod(task): void {
    if (task === 'maximize_chat_window') {
      window.LiveChatWidget.call('maximize');
    }
  }
}

export default new ChatWidget();
